import { gql } from '@apollo/client';

// 시스템 설정 조회
export const GET_SYSTEM_SETTINGS = gql`
  query GetSystemSettings {
    getSystemSettings {
      id
      maintenanceMode
      desktopMaintenanceImage
      mobileMaintenanceImage
      faviconUrl
      companyName
      businessNumber
      address
      phone
      fax
      email
      businessHours
      businessDays
      copyright
      orderSampleFileName
      orderSampleFileUrl
      createdAt
      updatedAt
    }
  }
`;

// 유지보수 모드 상태 확인
export const IS_MAINTENANCE_MODE = gql`
  query IsMaintenanceMode {
    isMaintenanceMode
  }
`;

// 시스템 설정 업데이트
export const UPDATE_SYSTEM_SETTINGS = gql`
  mutation UpdateSystemSettings($input: UpdateSystemSettingsInput!) {
    updateSystemSettings(input: $input) {
      success
      message
      settings {
        id
        maintenanceMode
        desktopMaintenanceImage
        mobileMaintenanceImage
        faviconUrl
        companyName
        businessNumber
        address
        phone
        fax
        email
        businessHours
        businessDays
        copyright
        orderSampleFileName
        orderSampleFileUrl
      }
    }
  }
`;

// 발주서 샘플 파일 업데이트
export const UPDATE_ORDER_SAMPLE_FILE = gql`
  mutation UpdateOrderSampleFile($fileName: String!, $fileUrl: String!) {
    updateOrderSampleFile(fileName: $fileName, fileUrl: $fileUrl) {
      success
      message
      settings {
        id
        orderSampleFileName
        orderSampleFileUrl
      }
    }
  }
`;

// 발주서 샘플 파일 삭제
export const DELETE_ORDER_SAMPLE_FILE = gql`
  mutation DeleteOrderSampleFile {
    deleteOrderSampleFile {
      success
      message
      settings {
        id
        orderSampleFileName
        orderSampleFileUrl
      }
    }
  }
`;

// 유지보수 모드 토글
export const TOGGLE_MAINTENANCE_MODE = gql`
  mutation ToggleMaintenanceMode {
    toggleMaintenanceMode {
      success
      message
      settings {
        id
        maintenanceMode
        desktopMaintenanceImage
        mobileMaintenanceImage
        faviconUrl
        companyName
        businessNumber
        address
        phone
        fax
        email
        businessHours
        businessDays
        copyright
        orderSampleFileName
        orderSampleFileUrl
      }
    }
  }
`;

// 파비콘 업데이트
export const UPDATE_FAVICON = gql`
  mutation UpdateFavicon($faviconUrl: String!) {
    updateFavicon(faviconUrl: $faviconUrl) {
      success
      message
      settings {
        id
        faviconUrl
      }
    }
  }
`;

// 파비콘 삭제
export const DELETE_FAVICON = gql`
  mutation DeleteFavicon {
    deleteFavicon {
      success
      message
      settings {
        id
        faviconUrl
      }
    }
  }
`; 